import { Popover } from 'sma.common/components/popover';

const ajax = require('sma.common/ajax');
const modals = require('sma.common/components/modals.js');

// Partials
const stagePreviewPartial = require('sma.applicant/detail/partials/stage_preview.mustache');
const collaboratorsPartial = require('sma.common/partials/collaborators.mustache');

const SubmitConfirm = require('sma.applicant/confirm_submit_modal');

const taskRecordPreviewUrlName = 'submission-taskrecord-preview';
const adminTaskRecordPreviewUrlName = 'submission-admin-taskrecord-preview';

class TaskRecordPreview extends Backbone.View {
	get events() {
		return {
			'click .sma-js-taskrecord-reset': 'resetTaskRecord',
			'click .sma-js-taskrecord-delete': 'deleteTaskRecord',
			'click .sma-js-taskrecord-edit': 'editTaskRecord',
			'click .sma-js-task-hide': 'hideTask',
			'click .sma-js-task-show': 'showTask',
			'click .sma-js-taskrecord-email': 'initiateEmail',
		};
	}

	constructor(config) {
		super();

		this.isAdmin = config.isAdmin;
		this.recordId = config.recordId;
		this.appId = config.appId;

		const previewUrlString = this.isAdmin ? adminTaskRecordPreviewUrlName : taskRecordPreviewUrlName;
		this.previewUrl = reverse(previewUrlString, {
			submission_id: this.appId,
			task_record_id: this.recordId,
		});

		const id = this.recordId.toString();
		const elementSelector = `#sma-js-task-preview-${id}`;
		const element = $(elementSelector)[0];

		this.setElement(element);
	}

	renderPreview() {
		const options = {
			url: this.previewUrl,
			callback: $.proxy(function (data) {
				const preview = data.html;
				if (preview) {
					const newHtml = $(preview);
					const innerHtml = newHtml.find('.sma-application-preview-task-container').html();
					$(this.el).html(innerHtml);
				}
			}, this),
		};
		ajax.get(options);
	}

	postAndRefresh(url, title, description) {
		const rerenderPreview = $.proxy(function () {
			this.renderPreview();
		}, this);

		new modals.Confirm(
			title,
			description,
			() => {
				const options = {
					url,
					callback: rerenderPreview,
				};
				ajax.post(options);
			},
		);
	}

	hideTask(e) {
		e.preventDefault();

		this.postAndRefresh(
			$(e.currentTarget).attr('href'),
			gettext('Hide task'),
			gettext('Are you sure that you want to hide this task from the applicant?'),
		);
	}

	showTask(e) {
		e.preventDefault();

		this.postAndRefresh(
			$(e.currentTarget).attr('href'),
			gettext('Show task'),
			gettext('Are you sure that you want to show this task to the applicant?'),
		);
	}

	resetTaskRecord(e) {
		e.preventDefault();

		const rerenderPreview = $.proxy(function () {
			this.renderPreview();
		}, this);

		new modals.CheckboxModal(
			gettext('Reset task'),
			gettext('Resetting the task will delete any task data previously collected for this application.'),
			gettext('Yes, I understand that resetting this task will permanently delete its data and that this action cannot be undone.'),
			() => {
				const options = {
					url: $(e.currentTarget).attr('href'),
					callback: rerenderPreview,
				};
				ajax.post(options);
			},
			{
				contingent: true,
				isDelete: true,
				okLabel: gettext('RESET'),
			},
		);
	}

	deleteTaskRecord(e) {
		e.preventDefault();

		this.postAndRefresh(
			$(e.currentTarget).attr('href'),
			gettext('Delete task'),
			gettext('Are you sure that you want to delete this record?'),
		);
	}

	initiateEmail(e) {
		e.preventDefault();

		$(e.currentTarget).find('form').submit();
	}

	editTaskRecord(e) {
		e.preventDefault();

		// Cheating a bit here, but this avoids having to hit the server for info that's already here just innacessible
		const taskHeader = $(e.currentTarget).closest('.sma-application-preview-task-container').find('.sma-application-preview-task-header');
		const taskTitle = taskHeader.find('.sma-application-preview-task-text h4')
			.first()
			.text()
			.trim();
		const applicant = $('.sma-admin-app-view-user-name').text();
		const recordId = $(e.currentTarget).data('record');
		const isRanking = $(e.currentTarget).data('is-ranking') === 'True';

		$('body').trigger('taskrecord:edit', [recordId, taskTitle, applicant, isRanking]);
	}
}

class StagePreview extends Backbone.View {
	constructor(config) {
		super();
		this.isAdmin = config.isAdmin;
		this.stageId = config.stageId;
		this.previewEl = config.previewEl;
		this.appId = config.appId;
		this.include_keys = config.include_keys || [];

		this.fromRound = config.fromRound || null;

		this.previewUrl = reverse(config.previewUrl, {
			submission_id: this.appId,
			stage_id: this.stageId,
		});

		const partial = stagePreviewPartial({ id: this.stageId });
		$(this.previewEl).append(partial);

		this.setElement($(`#sma-js-stage-preview-${this.stageId.toString()}`)[0]);

		this.renderPreview();
	}

	renderPreview() {
		const options = {
			url: this.previewUrl,
			data: {
				fromRound: this.fromRound,
				include_keys: this.include_keys,
			},
			callback: $.proxy(function (data) {
				const preview = data.html;
				const taskRecordIds = data.task_record_ids;
				const applicationId = data.application_id;

				if (preview) {
					$(this.el).html(preview);
				}
				if (taskRecordIds) {
					this.generateTasks(taskRecordIds, applicationId);
				}
			}, this),
		};
		ajax.get(options);
	}

	generateTasks(taskRecordIds, applicationId) {
		for (const taskRecordId of taskRecordIds) {
			const config = {
				recordId: taskRecordId,
				appId: applicationId,
				isAdmin: this.isAdmin,
			};
			new TaskRecordPreview(config);
		}
	}
}

class ApplicationDetails extends Backbone.View {
	get events() {
		return {
			'click .sma-js-remove-collaborator': 'removeCollaborator',
			'click .sma-js-make-owner': 'makeOwner',
			'click .sma-js-change-collaborator-access': 'changeCollaboratorAccess',
			'click .sma-js-download-application': 'downloadApplication',
			'click .sma-js-remove-team': 'removeTeam',
		};
	}

	constructor(config) {
		super();
		this.isAdmin = config.isAdmin;
		this.isApplicant = config.isApplicant;
		this.el = config.el;
		this.appId = config.appId;
		this.awardId = config.awardId;
		this.collaboratorsEl = [];
		this.collaborators = config.collaborators || [];

		this.url = reverse(config.url, {
			submission_id: this.appId,
		});

		if (this.isApplicant) {
			this.url += '?is_applicant=True';
		} else if (this.isAdmin) {
			this.url += '?is_admin=True';
		}
		this.setElement(this.el);

		this.render();
	}

	render() {
		const options = {
			url: this.url,
			callback: (response) => {
				$(this.el).html(response.html);
				this.collaboratorsEl = $('.sma-collaborators-popover-wrapper');
				if (this.collaboratorsEl.length > 0) {
					this.renderCollaboratorsPopover();
				}
			},
		};

		ajax.get(options);
	}

	removeCollaborator(e) {
		e.preventDefault();
		const target = $(e.currentTarget);

		const memberId = target.data('member-id');
		let url;

		if (!this.isAdmin) {
			url = reverse('remove-collaborator', {
				app_id: this.appId,
				member_id: memberId,
			});
		} else {
			url = reverse('admin-awards-remove-collaborator', {
				app_id: this.appId,
				member_id: memberId,
				pk: this.awardId,
			});
		}

		const options = {
			url,
			callback: (response) => {
				if (response.return_url) {
					window.location.href = response.return_url;
					return;
				}
				this.render();
			},
		};
		new modals.Confirm(
			gettext('Remove collaborator'),
			gettext('Are you sure that you want to remove this collaborator?'),
			() => {
				ajax.post(options);
			},
		);
	}

	removeTeam(e) {
		e.preventDefault();

		const url = reverse('admin-awards-remove-team', {
			pk: this.awardId,
			app_id: this.appId,
			team_id: $(e.currentTarget).data('team-id'),
		});

		new modals.Confirm(
			gettext('Remove team'),
			gettext('Are you sure that you want to remove this team?'),
			() => {
				ajax.post({
					url,
					callback: (response) => {
						if (response.return_url) {
							window.location.href = response.return_url;
							return;
						}
						this.render();
					},
				});
			},
		);
	}

	makeOwner(e) {
		e.preventDefault();
		const target = $(e.currentTarget);

		const memberId = target.data('member-id');

		const url = reverse('admin-awards-make-owner', {
			app_id: this.appId,
			member_id: memberId,
			pk: this.awardId,
		});

		const options = {
			url,
			callback: (_response) => {
				this.render();
			},
		};

		new modals.Confirm(
			gettext('Make owner'),
			gettext('Are you sure that you want to make this collaborator the application owner? The current owner will then become a collaborator.'),
			() => {
				ajax.post(options);
			},
		);
	}

	changeCollaboratorAccess(e) {
		e.preventDefault();
		const target = $(e.currentTarget);

		const memberId = target.data('member-id');

		const url = reverse('admin-awards-change-collaborator-access', {
			app_id: this.appId,
			member_id: memberId,
			pk: this.awardId,
		});

		const options = {
			url,
			callback: (_response) => {
				this.render();
			},
		};

		ajax.post(options);
	}

	downloadApplication(e) {
		e.preventDefault();

		const config = {
			download_format: 'as_single_file',
			submission_ids: this.appId,
			include_application_profiles: true,
		};

		ajax.post({
			url: reverse('download-redirect'),
			alertOnSuccess: false,
			data: config,
			callback: (response) => {
				if (response.url) {
					window.open(response.url, '_blank');
				}
			},
		});
	}

	renderCollaboratorsPopover() {
		const content = collaboratorsPartial({
			collaborators: this.collaborators,
			strings: {
				profile_picture: gettext('Profile picture'),
			},
		});
		const el = this.collaboratorsEl;

		const popover = new Popover({
			attachTo: el,
			content,
		});

		el.on('click', (e) => {
			if ($(e.target).hasClass('sma-popover') || $(e.target).parents('.sma-popover').length) {
				return false;
			}
			$('.sma-js-popover.sma-popover').fadeOut();
			popover.toggle();
		});

		$('body').on('click', (e) => {
			if ($(e.target).hasClass('sma-collaborators-popover-wrapper') || $(e.target).parents('.sma-collaborators-popover-wrapper').length) {
				return false;
			}
			$('.sma-js-popover.sma-popover').fadeOut();
		});
	}
}

class SubmitButtonArea extends Backbone.View {
	get events() {
		return {
			'click .sma-js-application-submit-button': 'showApplicationSubmitModal',
		};
	}

	constructor(config) {
		super();
		this.el = config.el;
		this.appId = config.appId;
		this.setElement(this.el);

		this.render();
	}

	showApplicationSubmitModal(e) {
		e.preventDefault();

		new SubmitConfirm({
			appId: this.appId,
			hideReviewButton: true,
			description: gettext('Please confirm submission of your application.'),
		});
	}
}

class ApplicationPreviewBase extends Backbone.View {
	constructor(config) {
		super();
		this.isAdmin = config.isAdmin || false;
		this.previewEl = config.previewEl;
		this.appId = config.application;
		this.stageIds = config.stageIds;
		this.previewUrl = config.previewUrl;
		this.detailsEl = config.detailsEl;
		this.isApplicant = config.isApplicant || false;
		this.detailsUrl = config.detailsUrl;
		this.fromRound = config.fromRound || null;
		this.include_keys = config.include_keys || [];
		this.submitButton = config.submitButton;
		this.collaborators = config.collaborators || [];

		this.setElement(this.previewEl);

		this.jumpToDropdown = $(this.el).find('.sma-js-jump-to-task');

		if (this.detailsEl) {
			this.renderDetails();
		}

		if (this.submitButton) {
			this.renderSubmitButton();
		}

		for (const stageId of this.stageIds) {
			this.createStage(stageId);
		}
	}

	renderDetails() {
		new ApplicationDetails({
			el: this.detailsEl,
			isAdmin: this.isAdmin,
			isApplicant: this.isApplicant,
			url: this.detailsUrl,
			appId: this.appId,
			collaborators: this.collaborators,
		});
	}

	renderSubmitButton() {
		new SubmitButtonArea({
			el: this.submitButton,
			appId: this.appId,
		});
	}

	createStage(stageId) {
		new StagePreview({
			previewEl: this.previewEl,
			appId: this.appId,
			stageId,
			previewUrl: this.previewUrl,
			isAdmin: this.isAdmin,
			fromRound: this.fromRound,
			include_keys: this.include_keys,
		});
	}
}

class ApplicationPreviewModal extends modals.Modal {
	constructor(config) {
		super();
		this.handleOptions(config);
		this.render();
		config.previewEl = this.modalBody;
		this.modalBody.addClass('sma-js-application-preview-container');

		this.applicationPreview = new ApplicationPreviewBase(config);
	}
}

module.exports = {
	ApplicationPreviewBase,
	TaskRecordPreview,
	ApplicationPreviewModal,
	ApplicationDetails,
};
